// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3F5vb","productName":"Table_productName__1k21-"};